import React, { useState } from 'react';
import classNames from 'classnames';
import { useTheme } from 'next-themes';
import Image from 'next/image';

import { ETheme } from '@/enums/theme';
import { CloseMobile } from '@/icons/index';

import Button from '../Button/Button';

import styles from './DownloadApplication.module.scss';

const DownloadApplication = ({ data }) => {
  const { theme } = useTheme();
  const [isAvailable, setIsAvailable] = useState(true);

  const handleDownload = () => {
    if (typeof window !== 'undefined') {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
      }
      if (/huawei/i.test(userAgent)) {
        return window.open(data?.download_link_huawei, '_blank');
      }
      if (/android/i.test(userAgent)) {
        return window.open(data?.download_link_android, '_blank');
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return window.open(data?.download_link_ios, '_blank');
      }

      return '';
    }
  };

  return (
    <div
      className={classNames([
        styles.download_app_wrapper,
        {
          [styles.none]: isAvailable !== true,
          [styles.dark]: theme === ETheme.DARK_MODE,
        },
      ])}
      itemScope
      itemType='https://schema.org/Article'
    >
      <div className={styles.content}>
        <CloseMobile
          onClick={() => {
            setIsAvailable(!isAvailable);
          }}
          className={styles.close_app}
        />
        {data?.icon && (
          <Image
            src={data?.icon}
            width={60}
            height={60}
            alt='Download Bakcell Application Logo'
            title='Download Bakcell Application Logo'
            className={styles.download_app_logo}
          />
        )}
        <div>
          <h6 className={styles.title}>{data?.title}</h6>
          <p className={styles.description}>{data?.description}</p>
        </div>
      </div>
      <Button className={styles.download_app_btn} onClick={handleDownload}>
        {data?.button_text}
      </Button>
    </div>
  );
};

export default DownloadApplication;
